import type * as React from 'react';

import { redirectTo, useLocation } from '@xing-com/crate-core-router';
import type { RoutesMap } from '@xing-com/crate-xinglet';

import { getPeoplePathRedirect } from './get-people-path-redirect';
import { RouteHandlerCity } from './route-handler-city';
import { RouteHandlerUsername } from './route-handler-username';

const NotFound: React.FC = () => {
  const { pathname, search } = useLocation();
  const redirectTarget = getPeoplePathRedirect(pathname, search);

  if (redirectTarget) {
    return redirectTo(redirectTarget, 301);
  }

  return redirectTo('/people');
};

export const routes: RoutesMap = {
  '/people/cities/:country/:city/:citySlugOrLetter': RouteHandlerCity,
  '/people/:slugOrLetter': RouteHandlerUsername,
  '/people/*notfound': NotFound,
};
